import { render, staticRenderFns } from "./Promo2019_Events.vue?vue&type=template&id=73cc5118&scoped=true&"
import script from "./Promo2019_Events.vue?vue&type=script&lang=js&"
export * from "./Promo2019_Events.vue?vue&type=script&lang=js&"
import style0 from "./Promo2019_Events.vue?vue&type=style&index=0&id=73cc5118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cc5118",
  null
  
)

export default component.exports